var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScissorscomb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52.2 52",
    style: {
      enableBackground: "new 0 0 52.2 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#8a8181;}\n\t.st1{fill:none;stroke:#8a8181;stroke-width:2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x30_5.-Desktop_x26_Mobile-Wires"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_.1-Desktop:-Hair-Quiz-Landing",
    transform: "translate(-39.000000, -494.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bitmap",
    transform: "translate(40.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.000000, 324.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fine-hair-quiz-355x600-_x28_1_x29_",
    transform: "translate(118.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st0",
    d: "M-90.9,19.2c-0.9,0.1-1.7,0.4-2.3,1l-1.6-18.8c0,0,0,0,0,0c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1 c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0 c-0.1-0.1-0.3-0.2-0.5-0.2c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c-0.1,0-0.1,0-0.1,0c0,0,0,0,0,0 c0,0-0.1,0-0.1,0.1c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1 c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0l-1.6,18.8c-0.6-0.5-1.4-0.9-2.3-1 c-2.3-0.2-4.3,1.6-4.4,3.8c-0.2,2,1,3.7,2.8,4.3c-0.2,0.6-0.7,0.9-0.7,0.9c-0.4,0.2-0.6,0.8-0.3,1.2c0.2,0.3,0.5,0.5,0.8,0.5 c0.1,0,0.3,0,0.4-0.1c0.1,0,1.3-0.7,1.7-2.3c1.9-0.2,3.5-1.8,3.6-3.8l1-11.7l1,11.7c0.2,2.2,2,3.9,4.1,3.9c0,0,0,0,0,0 c0.1,0,0.2,0,0.4,0c1.1-0.1,2.1-0.6,2.8-1.5s1-1.9,1-3.1C-86.7,20.8-88.7,19-90.9,19.2z M-100.9,25.8 c-1.3-0.1-2.3-1.3-2.2-2.6c0.1-1.2,1.1-2.2,2.4-2.2c0.1,0,0.1,0,0.2,0c1.3,0.1,2.3,1.3,2.2,2.6C-98.5,24.9-99.6,26-100.9,25.8 z M-88.2,23.2c0.1,0.6-0.1,1.3-0.5,1.8c-0.4,0.5-1,0.8-1.6,0.9c-1.3,0.1-2.5-0.9-2.6-2.2c-0.1-1.3,0.9-2.5,2.2-2.6 c0.1,0,0.1,0,0.2,0C-89.4,21-88.3,22-88.2,23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st0",
    d: "M-87.4,15.6c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h5.4v11c0,0.5,0.4,0.9,0.9,0.9 c0.5,0,0.9-0.4,0.9-0.9V3.2c0-1.8-1.4-3.2-3.2-3.2h-4c-0.5,0-0.9,0.4-0.9,0.9s0.4,0.9,0.9,0.9h4c0.8,0,1.4,0.7,1.4,1.5v0h-5.4 c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h5.4v1.3h-5.4c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h5.4v1.3h-5.4 c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h5.4v1.3h-5.4c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h5.4v1.3 L-87.4,15.6L-87.4,15.6z"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    className: "st1",
    cx: 25.2,
    cy: 26,
    r: 25
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScissorscomb);
export default __webpack_public_path__ + "static/media/scissorscomb.df4a3602.svg";
export { ForwardRef as ReactComponent };